import styled from 'styled-components';
import { Icon } from '../../../../iconsHelper';
import { Popup } from '../../styled/Popup.styled';
export const DisplateClubPopup = styled(Popup) `
  width: 300px;
`;
export const List = styled.ul `
  margin: 0;
  font-size: 12px;
  line-height: 24px;
`;
export const ListItem = styled.li `
  display: flex;
  align-items: center;
`;
export const ListItemIcon = styled(Icon) `
  margin-bottom: 0 !important;
`;
export const ListItemText = styled.div `
  margin-left: 10px;
`;
//# sourceMappingURL=DisplateClubPopup.styled.js.map